import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Inject, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HomeComponent } from './components/home/home.component';

import { BreezeBridgeHttpClientModule } from 'breeze-bridge2-angular';
import { MobxAngularModule } from 'mobx-angular';
import { UnitOfWorkService } from './services/unitOfWork/unitOfWork.service';
import { SetupGuard } from './guards/setup/setup.guard';
import { SigninOidcComponent } from './components/signin-oidc/signin-oidc.component';

import { environment } from '../environments/environment';
import { OpenIdConnectService } from './services/oidc/open-id-connect.service';
import { RequireAuthenticatedUserGuard } from './guards/auth/require-authenticated-user.guard';
import { RequireAdminGuard } from './guards/admin/require-admin-user.guard';
import { CanDeactivateGuard } from './guards/canDeactivate/can-deactivate.guard';
import { AddAuthorizationHeaderInterceptor } from './interceptors/add-authorization-header-interceptor';
import { SessionTimeoutComponent } from './components/session-timeout/session-timeout.component';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatButtonModule } from '@angular/material';
import { SignoutOidcComponent } from './components/signout-oidc/signout-oidc.component';

import * as breeze from 'breeze-client';
import { DocumentComponent } from './components/document/document.component';
import { BrowseComponent } from './components/browse/browse.component';
import { DownloadComponent } from './components/download/download.component';
import { AdminComponent } from './components/admin/admin.component';
import { FilterPipe } from './pipes/filter.pipe';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        SigninOidcComponent,
        SessionTimeoutComponent,
        SignoutOidcComponent,
        DocumentComponent,
        BrowseComponent,
        DownloadComponent,
        AdminComponent,
        FilterPipe
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        FormsModule,
        RouterModule.forRoot([
            {
                path: '', canActivate: [RequireAuthenticatedUserGuard, SetupGuard], children: [
                    { path: '', component: HomeComponent, data: { order: 1, name: 'Home' }, pathMatch: 'full' },
                    //{ path: 'download/:library/:id', component: DownloadComponent },
                    //{ path: 'document/:library/:id', component: DocumentComponent },
                    { path: 'browse/:library/:workspace/:id/:docid', component: BrowseComponent },
                    { path: 'browse/:library/:workspace/:id', component: BrowseComponent },
                    { path: 'browse/:library/:workspace', component: BrowseComponent },
                    { path: 'admin', canActivate: [RequireAdminGuard], canDeactivate: [CanDeactivateGuard], component: AdminComponent, data: { order: 2, name: 'Admin', admin: true } }
                ]
            },
            { path: 'signin-oidc', component: SigninOidcComponent },
            { path: 'signout-oidc', component: SignoutOidcComponent }
        ]),
        BreezeBridgeHttpClientModule,
        MobxAngularModule,
        BrowserAnimationsModule,
        NgIdleKeepaliveModule.forRoot(),
        MatDialogModule,
        MatButtonModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
    ],
    entryComponents: [
        SessionTimeoutComponent
    ],
    providers: [
        UnitOfWorkService,
        OpenIdConnectService,
        RequireAuthenticatedUserGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AddAuthorizationHeaderInterceptor,
            multi: true
        },
        RequireAdminGuard,
        CanDeactivateGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
